module.exports = __webpack_public_path__ + "img/26c0ade4a7140bd1960033a104b5775a.png";